import { Component, Input, Output, OnChanges, EventEmitter, SimpleChanges, HostListener, HostBinding, QueryList, ContentChildren, OnDestroy, ElementRef, Renderer, ViewChildren } from '@angular/core';
import { UserInputComponent } from '../user-input/user-input.component';
import { UserDateComponent } from '../user-date/user-date.component';
import { UserButtonComponent } from '../user-button/user-button.component';

import { UserFormService } from '../user-form/user-form.service';

@Component({
    selector: 'user-form',
    templateUrl: './user-form.component.html',
    providers: [UserFormService]
})
export class UserFormComponent {
    @HostBinding('class.form-invalid') get isInvalid() { return this.service.isInvalid; };
    set isInvalid(newValue: boolean) { this.service.isInvalid = newValue; }

    @HostBinding('class.form-haschanges') get hasChanges() { return this.service.hasChanges; };
    set hasChanges(newValue: boolean) { this.service.hasChanges = newValue; }

    @HostBinding('class.form-nochanges') get hasNoChanges() { return !this.service.hasChanges; };

    @ContentChildren(UserInputComponent, { descendants: true }) inputs: QueryList<UserInputComponent>;
    @ContentChildren(UserDateComponent, { descendants: true }) dates: QueryList<UserDateComponent>;

    constructor(private service: UserFormService, private ele: ElementRef, private renderer: Renderer) {
    }

    ngAfterViewInit() {
        this.inputs.changes.subscribe(() => {
            this.checkValidity();
        });

        this.dates.changes.subscribe(() => {
            this.checkValidity();
        });
        
        this.service.inputChanged.subscribe((evt: any) => {
            this.checkValidity();
            setTimeout(() => {
                this.hasChanges = true;
            });
        });

        this.service.setAsTouched.subscribe(() => {
            this.setAsTouched();
        });

        setTimeout(() => {
            this.checkValidity();
        });
    }

    checkValidity() {
        var isValid = true;
        for (let inp of this.inputs.toArray()) {
            if (!inp.isValid()) {
                isValid = false;
                break;
            }
        }

        for (let inp of this.dates.toArray()) {
            if (!inp.isValid()) {
                isValid = false;
                break;
            }
        }

        this.isInvalid = !isValid;
    }

    setAsTouched() {
        for (let inp of this.inputs.toArray()) {
            if (!inp.isValid()) {
                inp.controlTouched();
            }
        }

        for (let inp of this.dates.toArray()) {
            if (!inp.isValid()) {
                inp.controlTouched();
            }
        }
        
    }

}

interface IValidationMessage {
    value: any;
    message: string;
}
